@if (isLink) {
  <a
    [href]="url"
    class="be-logov2-logo-container"
    aria-label="Go to Best Egg homepage"
    role="link"
    >
    <svg class="be-logov2-icon" aria-hidden="true" viewBox="0 0 100 100">
      <use href="assets/icons-v2/sprites.svg#bestegg-logo"></use>
    </svg>
    <app-icon-wordmark></app-icon-wordmark>
  </a>
}

@if (!isLink) {
  <div
    class="be-logov2-logo-container"
    role="img"
    aria-label="Best Egg logo"
    >
    <svg class="be-logov2-icon" aria-hidden="true" viewBox="0 0 100 100">
      <use href="assets/icons-v2/sprites.svg#bestegg-logo"></use>
    </svg>
    <app-icon-wordmark></app-icon-wordmark>
  </div>
}
